@if (inventoryItem && inventoryItem.assignee) {
  <p-button-pure [icon]="'none'" [underline]="true" (click)="open = true">Unassign</p-button-pure>
}

<p-modal [open]="open" (dismiss)="close()">
  <p-heading slot="header" [size]="'large'" [tag]="'h2'">Unassign inventory item</p-heading>

  <form class="form" [formGroup]="form" [id]="formId" (ngSubmit)="submit()">
    <p-select-wrapper
      *ngrxLet="form.controls.locationId as control"
      [filter]="true"
      [label]="'Item returned to location: '"
      [message]="control.errors?.['message'] ?? ''"
      [state]="control.touched && control.errors ? 'error' : 'none'"
    >
      <select [attr.required]="true" [formControl]="control">
        <option
          *ngFor="let location of locations$ | async; trackBy: trackInventoryLocation"
          [value]="location.id"
        >
          {{ location.description }}
        </option>
      </select>
    </p-select-wrapper>
  </form>

  <p-button-group slot="footer">
    <p-button [form]="formId" [loading]="(submitting$ | async) ?? false" [type]="'submit'">
      Unassign
    </p-button>
    <p-button [iconSource]="'assets/icons/close.svg'" [variant]="'secondary'" (click)="close()">
      Close
    </p-button>
  </p-button-group>
</p-modal>
